import { useState } from 'preact/hooks';
export const useSideBarCollapse = () => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapse = () => {
    setCollapsed((value) => !value);
  };
  return { collapsed, toggleCollapse };
};
